import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice'
import headerReducer from './headerSlice'
import breadcrumbsReducer from './breadcrumbsSlice'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        header: headerReducer,
        breadcrumbs: breadcrumbsReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
})
